(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('FileStoreDetailController', FileStoreDetailController);

    FileStoreDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'FileStore', 'YieldCurveResults'];

    function FileStoreDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, FileStore, YieldCurveResults) {
        var vm = this;

        vm.fileStore = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:fileStoreUpdate', function(event, result) {
            vm.fileStore = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
